// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/*Number input*/\n\n.NumberInput {\n    display: flex;\n}\n\n.NumberInput .form-control {\n    background: white;\n    border: none;\n    padding: 0;\n    min-width: 4em;\n    text-align: center;\n\n}\n.NumberInput .btn {\n    min-width: 32px;\n    -webkit-border-radius: 10px;\n    -moz-border-radius: 10px;\n    border-radius: 10px;\n    margin: 0 5px;\n}", ""]);
// Exports
module.exports = exports;
